import { jsx as _jsx } from "react/jsx-runtime";
import { useOneOfField } from '../../hooks/one-of-field';
import { SchemaProvider } from '../../providers/SchemaProvider';
import { AutoField } from '../AutoField';
import { SchemaList } from './SchemaList';
export const OneOfField = ({ propName }) => {
    const { selectedOneOfSchema, oneOfSchemas, onSchemaChange, shouldRender } = useOneOfField(propName);
    const onCleanInput = () => {
        onSchemaChange();
    };
    if (!shouldRender) {
        return null;
    }
    return (_jsx(SchemaList, { propName: propName, selectedSchema: selectedOneOfSchema, schemas: oneOfSchemas, onChange: onSchemaChange, onCleanInput: onCleanInput, "aria-label": `${propName} oneof list`, "data-testid": `${propName}__oneof-list`, children: selectedOneOfSchema && (_jsx(SchemaProvider, { schema: selectedOneOfSchema.schema, children: _jsx(AutoField, { propName: propName }) })) }));
};
//# sourceMappingURL=OneOfField.js.map